import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const heroSections = document.querySelectorAll('.homepage-hero-section');
    if (!heroSections.length) {
        return;
    }

    const setHeaderHeight = () => {
        const header = document.querySelector('header');
        if (!header) {return;}

        const headerTop = header.querySelector('.header-top');
        const headerBottom = header.querySelector('.header-bottom');

        let totalHeight = 0;

        if (headerTop) {
            totalHeight = headerTop.offsetHeight + headerBottom.offsetHeight;
        } else {
            totalHeight = header.offsetHeight;
        }

        heroSections.forEach((heroSection) => {
            heroSection.style.setProperty('--header-height', `${totalHeight}px`);
        });
    };
    // Run once on load
    setHeaderHeight();

    // Run on resize
    window.addEventListener('resize', setHeaderHeight);

    heroSections.forEach((heroSection) => {
        const hhsAssetSlider = heroSection.querySelector('.hhs-asset-slider'); // Make sure to scope this to each section

        if (hhsAssetSlider) {
            new Swiper(hhsAssetSlider, {
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                pagination: {
                    el: hhsAssetSlider.querySelector('.hhs-asset-pagination'),
                    clickable: true,
                    type: 'fraction',
                },
                navigation: {
                    nextEl: hhsAssetSlider.parentNode.querySelector('.hhs-button-next'),
                    prevEl: hhsAssetSlider.parentNode.querySelector('.hhs-button-prev'),
                },
            });
        }
    });
});